// Format numbers with commas
const getLocaleString = (num) => {
    return num.toLocaleString("en", { useGrouping: true });
};

export default getLocaleString;
